module.exports = __webpack_public_path__ + "static/media/screenshot-ubl.f0a82d27.png";